//@vendor
const Immutable = require('immutable');
const { handleActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../actions/insuranceAssociatedMortgage');

const setInitialState = () => Immutable.fromJS({
    isFetching: false,
    error: false,
    success: false,
    insuranceAssociatedMortgage: []
});

const insuranceAssociatedMortgageReducer = handleActions(
    {
        [simpleActions.insuranceAssociatedMortgage]: state =>
            state.merge({
                isFetching: true,
                error: false,
                success: false
            }),
        [simpleActions.insuranceAssociatedMortgageSuccess]: (state, action) =>
            state.merge({
                isFetching: false,
                error: false,
                success: true,
                insuranceAssociatedMortgage: action.payload.data
            }),
        [simpleActions.insuranceAssociatedMortgageError]: (state, action) =>
            state.merge({
                isFetching: false,
                error: action.payload.error,
                success: false,
                insuranceAssociatedMortgage: []
            })
    },
    setInitialState()
);

module.exports = insuranceAssociatedMortgageReducer;
